// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Smooth Scroll */
html {
  scroll-behavior: smooth;
}

/* Remove default app center alignment */
.App {
  text-align: left;
}

/* Transitions for interactive elements only */
button, a, input, textarea, select {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Focus ring visibility */
*:focus-visible {
  outline: 2px solid #059669;
  outline-offset: 2px;
}

/* Image loading optimization */
img {
  max-width: 100%;
  height: auto;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #059669;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #047857;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,qGAAqG;AACvG;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Smooth Scroll */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Remove default app center alignment */\n.App {\n  text-align: left;\n}\n\n/* Transitions for interactive elements only */\nbutton, a, input, textarea, select {\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n/* Focus ring visibility */\n*:focus-visible {\n  outline: 2px solid #059669;\n  outline-offset: 2px;\n}\n\n/* Image loading optimization */\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #059669;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #047857;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
